import { LeanFormSchema, fieldRef } from '../types/config-form.types';
import { V3EpsSettings } from 'ngx-modbus';

export const EPS_FORM: LeanFormSchema = {
  version: '2.0.0',
  id: 'eps-settings',
  name: 'EPS Settings',
  sections: [{
    id: 'eps',
    labelKey: 'ePSSettings',
    registerTable: 'V3EpsSettings',
    fields: [
      fieldRef(V3EpsSettings, 'EPS_Control'),
    ],
  }],
};
